module.exports = __webpack_public_path__ + "img/banner1.f9577740.png";